import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import ResponsivePagination from 'react-responsive-pagination';
export default function DPaginator(_a) {
    var { navClassName } = _a, props = __rest(_a, ["navClassName"]);
    return (_jsx(ResponsivePagination, Object.assign({ navClassName: classNames('page-item-arrow', navClassName) }, props)));
}
//# sourceMappingURL=DPaginator.js.map